import React, {memo} from 'react';
import {
  LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, Brush
} from 'recharts';
import './ChartSignals.css'

// Custom Tooltip Component
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const ttip = (
        <>
        {!(data.buySignal == null && data.sellSignal == null) ? (data.buySignal == null ? `Sold at: ${data.close.toFixed(7)}` : `Bought at: ${data.close.toFixed(7)}`) : `${data.close.toFixed(7)}`}        
        <br/>
        {data.dateTime}</>
      );

    return (
      <div className="custom-tooltip" style={{color:data.buySignal !== null ? '#06ff00' : data.sellSignal !== null ? '#ff00c5' : '', textShadow:'-1px -1px 0 #131722, 1px -1px 0 #131722, -1px 1px 0 #131722, 1px 1px 0 #131722' }}>
        {ttip}        
      </div>
    );
  }

  return null;
};

const isToday = (dateTime) => {
  const today = new Date();
  const dateToCheck = new Date(dateTime);  
  return (
    today.getFullYear() === dateToCheck.getFullYear() &&
    today.getMonth() === dateToCheck.getMonth() &&
    today.getDate() === dateToCheck.getDate()
  );
};

const CustomBuyDot = (props) => {
  const { cx, cy, value, payload } = props;
  if (value) {
    const isTodaySignal = isToday(payload.dateTime);
    const blinkStyle = isTodaySignal
      ? {
          animation: 'blink 1s infinite',
        }
      : {};

    return (
      <svg
        x={cx - 5}
        y={cy - 5}
        width={15}
        height={15}
        viewBox="0 0 1024 1024"
        style={blinkStyle}
      >
        <path fill="#06ff00" d="M512 128L64 896h896z" />
        {/* Define the keyframes within the SVG */}
        <style>
          {`
            @keyframes blink {
              0%, 100% { opacity: 1; }
              50% { opacity: 0; }
            }
          `}
        </style>
      </svg>
    );
  }
  return null;
};

const CustomSellDot = (props) => {
  const { cx, cy, value, payload } = props;
  if (value) {
    const isTodaySignal = isToday(payload.dateTime);
    const blinkStyle = isTodaySignal
      ? {
          animation: 'blink 1s infinite',
        }
      : {};

    return (
      <svg
        x={cx - 5}
        y={cy - 5}
        width={15}
        height={15}
        viewBox="0 0 1024 1024"
        style={blinkStyle}
      >
        <path fill="#ff00c5" d="M512 896L64 128h896z" />
        {/* Define the keyframes within the SVG */}
        <style>
          {`
            @keyframes blink {
              0%, 100% { opacity: 1; }
              50% { opacity: 0; }
            }
          `}
        </style>
      </svg>
    );
  }
  return null;
};

const ChartSignals = memo(({ data, ticker, date_b, data_buy, date_s, data_sell }) => {

    const totalDataPoints = data.length;
    const interval = totalDataPoints > 5 ? Math.floor(totalDataPoints / 5) : 0;

    // Calculate the min and max Y values
    const minY = Math.min(...data.map(d => Math.min(d.seriesA, d.seriesB, d.seriesC)));
    const maxY = Math.max(...data.map(d => Math.max(d.seriesA, d.seriesB, d.seriesC)));

    // Adjust min and max for the domain
    const adjustedMinY = Math.max(0, minY - 10); // Adjust as needed
    const adjustedMaxY = maxY + 10; // Adjust as needed

    // Prepare the data for recharts
    const plotData = data.map((item, index) => ({
        dateTime: item.dateTime,
        close: item.close,
        buySignal: date_b.includes(item.dateTime) ? data_buy[date_b.indexOf(item.dateTime)] : null,
        sellSignal: date_s.includes(item.dateTime) ? data_sell[date_s.indexOf(item.dateTime)] : null
    }));

  return (    
    <div class="centered-div">
        <span class="centered-text">{ticker}</span>
        <ResponsiveContainer width="100%" height={400}>        
            <LineChart
                data={plotData}
                margin={{ top: 20, right: 30, left: 20, bottom: 30 }}
            >
            
                <XAxis dataKey="dateTime"
                interval={interval}
                angle={0}
                tick={{ fontSize: 10 }}
                />
                <YAxis 
                    domain={[adjustedMinY, adjustedMaxY]} // Set the custom domain
                    label={{ 
                        value: 'Price', 
                        angle: -90, 
                        position: 'insideLeft',
                        style: { textAnchor: 'middle' },
                        offset: 15
                    }}
                    hide={true}
                />

                <Tooltip content={<CustomTooltip />} />
                <Legend />
                <Line type="monotone" dataKey="close" stroke="#8884d8" dot={false} name='Price' strokeWidth={2}/>
                <Line type="monotone" dataKey="buySignal" stroke="#06ff00" dot={<CustomBuyDot />} name='Buy' />
                <Line type="monotone" dataKey="sellSignal" stroke="#ff00c5" dot={<CustomSellDot />} name='Sell'/>
                <Brush
                  dataKey="date_time"
                  height={20}
                  stroke="#8884d8"
                  fill="#f5f5f500"
                  travellerWidth={10}
                  gap={5} />
            </LineChart>
        </ResponsiveContainer>
    </div>
  );
});

export default ChartSignals;
